import React from 'react';

import PropTypes from 'prop-types';

import { FormSummaryKind } from '../../FormChangeHistory.constants';
import PrismPartsCount from '../PrismPartsCount';

/** The Template changes panel's count: a Prism change counts its parts; a file change has none. */
const TemplateChangesSubtitle = ({ changes, detail }) => {
  const prismChange = changes.find(
    change => change.summary?.kind === FormSummaryKind.PRISM_TEMPLATE,
  );

  return prismChange ? <PrismPartsCount change={prismChange} detail={detail} /> : null;
};

TemplateChangesSubtitle.propTypes = {
  changes: PropTypes.arrayOf(PropTypes.shape({ summary: PropTypes.object })).isRequired,
  detail: PropTypes.object.isRequired,
};

export default TemplateChangesSubtitle;
